import { AbpModule } from '@abp/abp.module';
import * as ngCommon from '@angular/common';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpClientJsonpModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { ChatSignalrService } from '@app/shared/layout/chat/chat-signalr.service';
import { LinkAccountModalComponent } from '@app/shared/layout/link-account-modal.component';
import { LinkedAccountsModalComponent } from '@app/shared/layout/linked-accounts-modal.component';
import { LoginAttemptsModalComponent } from '@app/shared/layout/login-attempts-modal.component';
import { ChangePasswordModalComponent } from '@app/shared/layout/profile/change-password-modal.component';
import { ChangeProfilePictureModalComponent } from '@app/shared/layout/profile/change-profile-picture-modal.component';
import { SmsVerificationModalComponent } from '@app/shared/layout/profile/sms-verification-modal.component';
import { ServiceProxyModule } from '@shared/service-proxies/service-proxy.module';
import { UtilsModule } from '@shared/utils/utils.module';
import { FileUploadModule } from 'ng2-file-upload';
import { ModalModule, TabsModule, TooltipModule, BsDropdownModule } from 'ngx-bootstrap';
import { FileUploadModule as PrimeNgFileUploadModule, PaginatorModule, ProgressBarModule, SharedModule } from 'primeng/primeng';
import { TableModule } from 'primeng/table';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent, MyErrorHandler } from './app.component';
import { DefaultLayoutComponent } from './shared/layout/themes/default/default-layout.component';
import { Theme8LayoutComponent } from './shared/layout/themes/theme8/theme8-layout.component';
import { Theme2LayoutComponent } from './shared/layout/themes/theme2/theme2-layout.component';
import { Theme11LayoutComponent } from './shared/layout/themes/theme11/theme11-layout.component';
import { Theme3LayoutComponent } from './shared/layout/themes/theme3/theme3-layout.component';
import { Theme7LayoutComponent } from './shared/layout/themes/theme7/theme7-layout.component';
import { AppCommonModule } from './shared/common/app-common.module';
import { ChatBarComponent } from './shared/layout/chat/chat-bar.component';
import { ChatFriendListItemComponent } from './shared/layout/chat/chat-friend-list-item.component';
import { ChatMessageComponent } from './shared/layout/chat/chat-message.component';
import { FooterComponent } from './shared/layout/footer.component';
import { LinkedAccountService } from './shared/layout/linked-account.service';
import { SideBarMenuComponent } from './shared/layout/nav/side-bar-menu.component';
import { TopBarMenuComponent } from './shared/layout/nav/top-bar-menu.component';
import { TopBarComponent } from './shared/layout/topbar.component';
import { DefaultBrandComponent } from './shared/layout/themes/default/default-brand.component';
import { Theme8BrandComponent } from './shared/layout/themes/theme8/theme8-brand.component';
import { Theme2BrandComponent } from './shared/layout/themes/theme2/theme2-brand.component';
import { Theme11BrandComponent } from './shared/layout/themes/theme11/theme11-brand.component';
import { Theme3BrandComponent } from './shared/layout/themes/theme3/theme3-brand.component';
import { Theme7BrandComponent } from './shared/layout/themes/theme7/theme7-brand.component';
import { UserNotificationHelper } from './shared/layout/notifications/UserNotificationHelper';
import { HeaderNotificationsComponent } from './shared/layout/notifications/header-notifications.component';
import { NotificationSettingsModalComponent } from './shared/layout/notifications/notification-settings-modal.component';
import { NotificationsComponent } from './shared/layout/notifications/notifications.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { HttpModule, Http } from '@angular/http';

import { BsDatepickerModule, BsDatepickerConfig, BsDaterangepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';

// Metronic
import { PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    // suppressScrollX: true
};

import { CoreModule } from '@metronic/app/core/core.module';

import { LayoutConfigService } from '@metronic/app/core/services/layout-config.service';
import { UtilsService } from '@metronic/app/core/services/utils.service';
import { LayoutRefService } from '@metronic/app/core/services/layout/layout-ref.service';
import { AppAuthService } from './shared/common/auth/app-auth.service';
import { MonitorServiceService } from '@shared/AzureLogging/monitor-service.service';
import { ExampleService } from '@shared/example.service';
import { NgxBootstrapDatePickerConfigService } from 'assets/ngx-bootstrap/ngx-bootstrap-datepicker-config.service';
import { FinancialRoutingModule } from './main/my-financials/financial-routing.module';
import { GlobalFilterYearNavComponent } from './shared/layout/nav/global-filter-year-nav/global-filter-year-nav.component';
import { MyHealthcareModule } from './main/my-healthcare/my-healthcare.module';
import { MyWearablesModule } from './main/my-wearables/my-wearables.module';
import { AuthInterceptorService } from './shared/services/auth-interceptor.service';
import { ProductService } from './shared/services/product.service';
import { GroupByPipe } from '@shared/common/pipes/commonElevate.pipe';
import {FileUploaderComponent} from '@app/shared/common/file-uploader/file-uploader.component';
import { SavingUploadModalComponent } from './main/my-goals/saving-upload-modal/saving-upload-modal.component';
import { TruIDUploadModalComponent } from './main/human-api-authentication/truID-upload-modal/truID-upload-modal.component';
import { ElevateMeFasterUploadModalComponent } from './main/my-goals/elevate-me-faster-upload-modal/elevate-me-faster-upload-modal.component';
import { MatCheckboxModule } from '@node_modules/@angular/material/checkbox';
import { SharedModuleModule } from './shared/shared-module/shared-module.module';
//import { GlobalFilterMonthNavComponent } from './shared/layout/nav/global-filter-month-nav/global-filter-month-nav.component';
//import { ImagePipeActivity } from './main/my-wearables/my-wearables.component';


@NgModule({
    declarations: [
        AppComponent,
        DefaultLayoutComponent,
        Theme8LayoutComponent,
        Theme2LayoutComponent,
        Theme3LayoutComponent,
        Theme7LayoutComponent,
        Theme11LayoutComponent,
        HeaderNotificationsComponent,
        SideBarMenuComponent,
        TopBarMenuComponent,
        FooterComponent,
        LoginAttemptsModalComponent,
        LinkedAccountsModalComponent,
        LinkAccountModalComponent,
        ChangePasswordModalComponent,
        ChangeProfilePictureModalComponent,
        // SmsVerificationModalComponent,
        NotificationsComponent,
        ChatBarComponent,
        ChatFriendListItemComponent,
        NotificationSettingsModalComponent,
        ChatMessageComponent,
        TopBarComponent,
        DefaultBrandComponent,
        Theme8BrandComponent,
        Theme2BrandComponent,
        Theme3BrandComponent,
        Theme7BrandComponent,
        Theme11BrandComponent,
        FileUploaderComponent,
        SavingUploadModalComponent,
        TruIDUploadModalComponent,
        ElevateMeFasterUploadModalComponent
        // GlobalFilterYearNavComponent,
        // GlobalFilterMonthNavComponent,
        //ImagePipeActivity
    ],
    imports: [
        ngCommon.CommonModule,
        FormsModule,
        HttpClientModule,
        HttpClientJsonpModule,
        ModalModule.forRoot(),
        TooltipModule.forRoot(),
        TabsModule.forRoot(),
        BsDropdownModule.forRoot(),
        FileUploadModule,
        AbpModule,
        HttpModule,
        AppRoutingModule,
        UtilsModule,
        AppCommonModule.forRoot(),
        ServiceProxyModule,
        TableModule,
        PaginatorModule,
        PrimeNgFileUploadModule,
        ProgressBarModule,
        PerfectScrollbarModule,
        CoreModule,
        ImageCropperModule,
        BsDatepickerModule.forRoot(),
        MyHealthcareModule,
        MyWearablesModule,
        MatCheckboxModule,
        SharedModuleModule
    ],
    exports: [
        FileUploaderComponent
    ],
    entryComponents: [
        SavingUploadModalComponent,
        TruIDUploadModalComponent,
        ElevateMeFasterUploadModalComponent
    ],
    providers: [
        ExampleService,
        {
            provide: ErrorHandler,
            useClass: MonitorServiceService
        },
        {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true},

        AppAuthService,
        LinkedAccountService,
        UserNotificationHelper,
        ChatSignalrService,
        ProductService,
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        },
        LayoutConfigService,
        UtilsService,
        LayoutRefService,
        {provide: BsDatepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerConfig},
        {provide: BsDaterangepickerConfig, useFactory: NgxBootstrapDatePickerConfigService.getDaterangepickerConfig},
        {provide: BsLocaleService, useFactory: NgxBootstrapDatePickerConfigService.getDatepickerLocale}
    ]
})
export class AppModule { }



